import React from 'react';
import { mockCompanies } from '../data/companies';
import { CompanyCard } from './CompanyCard';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/Select';
import { LayoutGrid, List, Info } from 'lucide-react';
export function CompanyDirectory() {
  return <main className="flex-1 overflow-y-auto bg-muted/10 p-4 md:p-6" data-id="element-82">
      <div className="max-w-6xl mx-auto space-y-4" data-id="element-83">
        {/* Top Bar */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-4 border-b border-border/50" data-id="element-84">
          <div className="flex flex-col gap-1" data-id="element-85">
            <div className="flex items-baseline gap-2" data-id="element-86">
              <h2 className="font-heading text-lg font-bold text-foreground tracking-tight" data-id="element-87">
                Company Directory
              </h2>
              <span className="font-mono text-xs text-muted-foreground" data-id="element-88">
                {mockCompanies.length} companies
              </span>
            </div>
            <div className="flex items-center gap-1.5 text-[10px] font-mono text-muted-foreground" data-id="element-89">
              <Info className="w-3 h-3" data-id="element-90" />
              <span data-id="element-91">
                Hover over{' '}
                <span className="border-b border-dotted border-muted-foreground/50" data-id="element-92">
                  underlined items
                </span>{' '}
                and{' '}
                <span className="bg-emerald-500/10 text-emerald-600 px-1 rounded-sm" data-id="element-93">
                  signal badges
                </span>{' '}
                for details & sources
              </span>
            </div>
          </div>

          <div className="flex items-center gap-3" data-id="element-94">
            {/* Match legend */}
            <div className="hidden lg:flex items-center gap-2 mr-2" data-id="element-95">
              <div className="flex items-center gap-1" data-id="element-96">
                <span className="w-2 h-2 rounded-full bg-emerald-500" data-id="element-97" />
                <span className="text-[10px] font-mono text-muted-foreground" data-id="element-98">
                  80%+
                </span>
              </div>
              <div className="flex items-center gap-1" data-id="element-99">
                <span className="w-2 h-2 rounded-full bg-amber-500" data-id="element-100" />
                <span className="text-[10px] font-mono text-muted-foreground" data-id="element-101">
                  50-79%
                </span>
              </div>
              <div className="flex items-center gap-1" data-id="element-102">
                <span className="w-2 h-2 rounded-full bg-red-500" data-id="element-103" />
                <span className="text-[10px] font-mono text-muted-foreground" data-id="element-104">
                  &lt;50%
                </span>
              </div>
            </div>

            <div className="flex items-center gap-2" data-id="element-105">
              <span className="font-mono text-[11px] text-muted-foreground uppercase tracking-wider" data-id="element-106">
                Sort by:
              </span>
              <Select defaultValue="match" data-id="element-107">
                <SelectTrigger className="h-7 w-[140px] text-xs font-mono bg-background border-border/60 rounded-sm" data-id="element-108">
                  <SelectValue placeholder="Sort by" data-id="element-109" />
                </SelectTrigger>
                <SelectContent data-id="element-110">
                  <SelectItem value="match" className="text-xs font-mono" data-id="element-111">
                    Best match
                  </SelectItem>
                  <SelectItem value="recent" className="text-xs font-mono" data-id="element-112">
                    Recently updated
                  </SelectItem>
                  <SelectItem value="size" className="text-xs font-mono" data-id="element-113">
                    Company size
                  </SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="hidden sm:flex items-center border border-border/60 rounded-sm bg-background overflow-hidden" data-id="element-114">
              <button className="p-1.5 bg-muted text-foreground" data-id="element-115">
                <LayoutGrid className="w-3.5 h-3.5" data-id="element-116" />
              </button>
              <button className="p-1.5 text-muted-foreground hover:bg-muted/50 transition-colors" data-id="element-117">
                <List className="w-3.5 h-3.5" data-id="element-118" />
              </button>
            </div>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4" data-id="element-119">
          {mockCompanies.map(company => <CompanyCard key={company.id} company={company} data-id="element-120" />)}
        </div>
      </div>
    </main>;
}